import axios from "axios";

import Config from "./Config";
import APIHelper from "./APIHelper";

const URLVerificationService = {
    getAll() {
        return axios
            .get(`${Config.API_URL}url-verification`)
            .then((response) => {
                if (!APIHelper.checkStatus(response)) {
                    return false;
                }
                return response.data.data || false;
            })
            .catch(APIHelper.returnFalse);
    },

    updateStatus(ids, status) {
        return axios
            .put(`${Config.API_URL}url-verification`, { ids, status })
            .then(APIHelper.checkStatus)
            .catch(APIHelper.returnFalse);
    },
};

export default URLVerificationService;
